module.exports = __webpack_public_path__ + "media/site/images/logo-35ee30eaa7d2215526f65418947683e3.svg";